import { LegalPage } from '../components/Legal/LegalPage';

export const CookiePolicyPage = () => {
  return <LegalPage title="Cookie Policy" filename="cookie-policy.md" />;
};